export default __webpack_public_path__ + "static/media/CV_2024.9f339425.pdf";